/**
 * Bowmar Nutrition — Protein Recipe Book
 * Client-side filtering and modal for server-rendered recipe cards.
 */
(function () {
  'use strict';

  var grid = document.getElementById('recipe-cards');
  var noResults = document.getElementById('no-results');
  var recipeCount = document.getElementById('recipe-count');
  var activeFilters = document.getElementById('active-filters');
  var modal = document.getElementById('recipe-modal');
  var modalBody = document.getElementById('modal-body');
  var modalClose = document.getElementById('modal-close');
  var modalBackdrop = document.getElementById('modal-backdrop');
  var filterFlavor = document.getElementById('filter-flavor');
  var filterCategory = document.getElementById('filter-category');
  var filterDifficulty = document.getElementById('filter-difficulty');
  var filterSearch = document.getElementById('filter-search');

  if (!grid || !filterFlavor) return;

  var allCards = Array.from(grid.querySelectorAll('.br-card'));

  if (recipeCount) recipeCount.textContent = allCards.length + ' recipe' + (allCards.length !== 1 ? 's' : '');

  /* ── Filtering ── */
  function applyFilters() {
    var flavor = filterFlavor.value;
    var category = filterCategory.value;
    var difficulty = filterDifficulty.value;
    var search = filterSearch.value.toLowerCase().trim();
    var visible = 0;

    allCards.forEach(function (card) {
      var show = true;
      if (flavor !== 'all' && card.dataset.flavor !== flavor) show = false;
      if (category !== 'all' && card.dataset.category !== category) show = false;
      if (difficulty !== 'all' && card.dataset.difficulty !== difficulty) show = false;
      if (search) {
        var t = (card.dataset.title || '') + ' ' + (card.dataset.tags || '') + ' ' + (card.dataset.flavor || '').toLowerCase();
        if (t.indexOf(search) === -1) show = false;
      }
      card.style.display = show ? '' : 'none';
      if (show) visible++;
    });

    if (recipeCount) recipeCount.textContent = visible + ' recipe' + (visible !== 1 ? 's' : '');
    if (noResults) noResults.style.display = visible === 0 ? 'block' : 'none';
    renderActiveTags();
  }

  function renderActiveTags() {
    if (!activeFilters) return;
    var tags = [];
    if (filterFlavor.value !== 'all') tags.push({ label: filterFlavor.value, filter: 'flavor' });
    if (filterCategory.value !== 'all') tags.push({ label: filterCategory.value, filter: 'category' });
    if (filterDifficulty.value !== 'all') tags.push({ label: filterDifficulty.value, filter: 'difficulty' });
    if (filterSearch.value.trim()) tags.push({ label: '"' + filterSearch.value.trim() + '"', filter: 'search' });

    activeFilters.innerHTML = tags.map(function (t) {
      return '<span class="br-filters__tag">' + esc(t.label) + '<button class="br-filters__tag-remove" data-filter="' + t.filter + '">&times;</button></span>';
    }).join('');

    activeFilters.querySelectorAll('.br-filters__tag-remove').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var f = btn.dataset.filter;
        if (f === 'flavor') filterFlavor.value = 'all';
        if (f === 'category') filterCategory.value = 'all';
        if (f === 'difficulty') filterDifficulty.value = 'all';
        if (f === 'search') filterSearch.value = '';
        applyFilters();
      });
    });
  }

  filterFlavor.addEventListener('change', applyFilters);
  filterCategory.addEventListener('change', applyFilters);
  filterDifficulty.addEventListener('change', applyFilters);
  var searchTimeout;
  filterSearch.addEventListener('input', function () {
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(applyFilters, 300);
  });

  /* ── Card Click → Modal ── */
  allCards.forEach(function (card) {
    card.addEventListener('click', function (e) {
      e.preventDefault();
      var d = card.dataset;
      var ingredients = [];
      var instructions = [];

      try { ingredients = JSON.parse(d.ingredients || '[]'); } catch (ex) { ingredients = []; }
      try { instructions = JSON.parse(d.instructions || '[]'); } catch (ex) { instructions = []; }

      openModal({
        title: d.slug ? card.querySelector('.br-card__title').textContent : 'Recipe',
        description: d.description || '',
        protein_flavor: d.flavor || '',
        category: d.category || '',
        difficulty: d.difficulty || 'Easy',
        prep_time: parseInt(d.prep) || 0,
        cook_time: parseInt(d.cook) || 0,
        servings: parseInt(d.servings) || 1,
        calories: parseInt(d.calories) || 0,
        protein_grams: parseInt(d.protein) || 0,
        carbs_grams: parseInt(d.carbs) || 0,
        fat_grams: parseInt(d.fat) || 0,
        ingredients: ingredients,
        instructions: instructions
      });
    });
  });

  /* ── Modal ── */
  function openModal(r) {
    var totalTime = r.prep_time + r.cook_time;

    modalBody.innerHTML =
      '<div class="br-recipe__details" style="padding-top:16px;">' +
        '<h2 style="font-size:1.75rem;font-weight:700;margin:0 0 12px;">' + esc(r.title) + '</h2>' +
        '<div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:24px;">' +
          '<span class="br-recipe__tag" style="background:rgba(93,205,245,0.15);color:#3ab8e8;border:1px solid rgba(93,205,245,0.3);">' + esc(r.protein_flavor) + '</span>' +
          '<span class="br-recipe__tag" style="background:rgba(93,205,245,0.15);color:#3ab8e8;border:1px solid rgba(93,205,245,0.3);">' + esc(r.category) + '</span>' +
          '<span class="br-recipe__tag" style="background:rgba(93,205,245,0.15);color:#3ab8e8;border:1px solid rgba(93,205,245,0.3);">' + esc(r.difficulty) + '</span>' +
        '</div>' +
        '<div class="br-recipe__quick-stats">' +
          (totalTime ? '<div class="br-recipe__stat"><span class="br-recipe__stat-value">' + totalTime + '</span><span class="br-recipe__stat-label">Minutes</span></div>' : '') +
          '<div class="br-recipe__stat"><span class="br-recipe__stat-value">' + r.servings + '</span><span class="br-recipe__stat-label">Servings</span></div>' +
          '<div class="br-recipe__stat"><span class="br-recipe__stat-value">' + r.calories + '</span><span class="br-recipe__stat-label">Calories</span></div>' +
          '<div class="br-recipe__stat"><span class="br-recipe__stat-value">' + r.protein_grams + 'g</span><span class="br-recipe__stat-label">Protein</span></div>' +
        '</div>' +
        (r.description ? '<p class="br-recipe__description">' + esc(r.description) + '</p>' : '') +
        '<h3 class="br-recipe__section-title">Ingredients</h3>' +
        '<ul class="br-recipe__ingredients">' +
          r.ingredients.map(function (i) { return '<li>' + esc(i) + '</li>'; }).join('') +
        '</ul>' +
        '<h3 class="br-recipe__section-title">Instructions</h3>' +
        '<ol class="br-recipe__instructions">' +
          r.instructions.map(function (s) { return '<li>' + esc(s) + '</li>'; }).join('') +
        '</ol>' +
        '<h3 class="br-recipe__section-title">Nutrition per Serving</h3>' +
        '<div class="br-recipe__nutrition">' +
          '<div class="br-recipe__nutrition-item"><span class="br-recipe__nutrition-value">' + r.calories + '</span><span class="br-recipe__nutrition-label">Calories</span></div>' +
          '<div class="br-recipe__nutrition-item"><span class="br-recipe__nutrition-value">' + r.protein_grams + 'g</span><span class="br-recipe__nutrition-label">Protein</span></div>' +
          '<div class="br-recipe__nutrition-item"><span class="br-recipe__nutrition-value">' + r.carbs_grams + 'g</span><span class="br-recipe__nutrition-label">Carbs</span></div>' +
          '<div class="br-recipe__nutrition-item"><span class="br-recipe__nutrition-value">' + r.fat_grams + 'g</span><span class="br-recipe__nutrition-label">Fat</span></div>' +
        '</div>' +
      '</div>';

    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (modalClose) modalClose.addEventListener('click', closeModal);
  if (modalBackdrop) modalBackdrop.addEventListener('click', closeModal);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && modal.getAttribute('aria-hidden') === 'false') closeModal();
  });

  function esc(str) {
    if (!str) return '';
    var d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }
})();
